import clsx from 'clsx';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import React from 'react';
import Container from '../../components/Container';
import PageHeader from '../../components/PageHeader';
import StakingInfo from '../../components/StakingInfo';
import StakingPreview from '../../components/StakingPreview';
import config from '../../config';
import { useAlgo } from '../../hooks/useAlgo';
import { useCollection } from '../../hooks/useCollection';
import { useStaking } from '../../hooks/useStaking';

const ConnectWalletButton = dynamic(() => import('../../components/ConnectWalletButton'), { ssr: false });

function Staking() {
  const { myDarumas } = useCollection();
  const { address } = useAlgo();
  const { totalStaked, currentPeriod } = useStaking();

  return (
    <>
      <NextSeo title={`Staking - ${config.siteName}`} />
      <PageHeader heading={'Staking'} description='Stake your AlgoDaruma for KARMA.'>
        <div>
          <p className='text-lg font-medium text-gray-500'>
            <strong>Total Staked:</strong> {totalStaked}
          </p>
          <p className='text-lg font-medium text-gray-500'>
            <strong>Staking Period:</strong> {currentPeriod.start} - {currentPeriod.end}
          </p>
        </div>
      </PageHeader>

      {address ? (
        <Container
          className={clsx(
            ' mx-auto grid gap-5',
            myDarumas.length === 1 ? 'mx-auto grid-cols-1 max-w-[400px]' : 'grid-cols-1 md:grid-cols-3 max-w-6xl'
          )}
        >
          {myDarumas.map((it, index) => (
            <StakingPreview key={index} daruma={it} />
          ))}
        </Container>
      ) : (
        <div className='flex justify-center'>
          <ConnectWalletButton />
        </div>
      )}

      <StakingInfo />
    </>
  );
}

export default Staking;
